import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AuthService from "services/auth.service";
import {API_URL_IMAGE} from "../../services/config";

import { Row, Col, Input } from "reactstrap";

const User = (props) => {
  const { id } = useParams();
  let navigate = useNavigate();

  const initialUserState = {
    id: null,
    email: "",
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    mobileNumber: "",
    ssn: "",
    address: "",
    gender: "",
    availableBalance: "",
    pendingPayment: "",
    transactionTotalFee: "",
    transactionRefundableFee: "",
  };

  const [currentUser, setCurrentUser] = useState(initialUserState);
  const [message, setMessage] = useState("");
  const [file, setFile] = useState();
  const [imageURL, setImageURL] = useState("");
  const [successful, setSuccessful] = useState(false);

  const saveFile = (e) => {
    e.preventDefault();
    setFile(e.target.files[0]);
  };

  const getUser = (id) => {
    AuthService.get(id)
      .then((response) => {
        setCurrentUser(response.data);
        //console.log(response.data);
      })
      .catch((e) => {
        //console.log(e);
      });
  };

  useEffect(() => {
    if (id) getUser(id);
  }, [id]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCurrentUser({ ...currentUser, [name]: value });
  };

  //   const updatePublished = status => {
  //     var data = {
  //       id: currentUser.id,
  //       title: currentUser.title,
  //       description: currentUser.description,
  //       published: status
  //     };

  //     AuthService.update(currentUser.id, data)
  //       .then(response => {
  //         setCurrentUser({ ...currentUser, published: status });
  //         console.log(response.data);
  //       })
  //       .catch(e => {
  //         console.log(e);
  //       });
  //   };

  const handleImageUpload = async () => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await AuthService.upload(formData);
      setMessage(response.imageUrl);
      //console.log(response.imageUrl);
      setImageURL(`${API_URL_IMAGE}${response.imageUrl}`);
      setSuccessful(true);
      return response; // Return the response data
    } catch (error) {
      // Handle errors here
      const resMessage =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      setMessage(resMessage);
      setSuccessful(false);
      throw error; // Re-throw the error to be caught by the caller
    }
  };

  const updateUser = async () => {
    try {
      let imageResponse = null;
  
      // Check if a file is selected
      if (file) {
        // If a file is selected, upload the image
        imageResponse = await handleImageUpload();
      }
  
      // Extract password from currentUser to prevent rehashing
      const { password, ...userDataWithoutPassword } = currentUser;
  
      // Include image URL in user data if available
      const userDataWithImage = {
        ...userDataWithoutPassword,
        imageURL: imageResponse ? imageResponse.imageUrl : null
      };
  
      // Update user data
      const response = await AuthService.update(currentUser.id, userDataWithImage);
      //console.log(response.data);
      setMessage("The User was updated successfully!");
    } catch (error) {
      //console.log(error);
      // Handle errors here
      const errorMessage =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      setMessage(errorMessage);
    }
  };
  

  const deleteUser = () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this user?\n\nThis action will also permanently delete:\n• user's conversations\n• chat messages\n\nThis action cannot be undone."
    );

      if (confirmDelete) {
    AuthService.remove(currentUser.id)
      .then((response) => {
        //console.log(response.data);
        navigate("/admin/users");
      })
      .catch((e) => {
        //console.log(e);
      });
    };
  };

  return (
    <div className="content">
      <Row>
        <Col>
          {currentUser ? (
            <div className="edit-form">
              <h4>User</h4>
              <form>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="email"
                    value={currentUser.email}
                    onChange={handleInputChange}
                    //   validations={[required, validEmail]}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="firstname">First Name</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="firstName"
                    value={currentUser.firstName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastname">Last Name</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="lastName"
                    value={currentUser.lastName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="dob">Date of Birth (YYY/MM/DD)</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="dateOfBirth"
                    value={currentUser.dateOfBirth}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="mobile">mobile number</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="mobileNumber"
                    value={currentUser.mobileNumber}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="ssn">SSN</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="ssn"
                    value={currentUser.ssn}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="address">address</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="address"
                    value={currentUser.address}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="gender">Gender</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="gender"
                    value={currentUser.gender}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="available">Available Escrow Balance</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="availableBalance"
                    value={currentUser.availableBalance}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="pending">Pending Balance</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="pendingPayment"
                    value={currentUser.pendingPayment}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="transactionTotalFee">
                    Total amount for Non Refundable (TotalFee)
                  </label>
                  <Input
                    type="text"
                    className="form-control"
                    name="transactionTotalFee"
                    value={currentUser.transactionTotalFee}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="transactionRefundableFee">
                    Transaction Page refundable Fee Total
                  </label>
                  <Input
                    type="text"
                    className="form-control"
                    name="transactionRefundableFee"
                    value={currentUser.transactionRefundableFee}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="imagePath">Image</label>
                  <Input
                    type="file"
                    className="form-control"
                    name="imagePath"
                    onChange={saveFile}
                    required
                  />
                  {/* {imagePath && <p>Selected File: {imagePath}</p>} */}
                </div>

                {/* <div className="form-group">
              <label>
                <strong>Status:</strong>
              </label>
              {currentUser.published ? "Published" : "Pending"}
            </div> */}
              </form>

              {/* {currentUser.published ? (
            <button
              className="badge badge-primary mr-2"
              onClick={() => updatePublished(false)}
            >
              UnPublish
            </button>
          ) : (
            <button
              className="badge badge-primary mr-2"
              onClick={() => updatePublished(true)}
            >
              Publish
            </button>
          )} */}

              <button className="badge badge-danger mr-2" onClick={deleteUser}>
                Delete
              </button>

              <button
                type="submit"
                className="badge badge-success"
                onClick={updateUser}
              >
                Update
              </button>
              <p>{message}</p>
            </div>
          ) : (
            <div>
              <br />
              <p>Please click on a User...</p>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default User;
